import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useParams, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import axios from 'axios';
import StandindRow from './standingTableRow';
import StandingOwnerTableRow from './standingOwnerTableRow';

const useStyles = makeStyles(() => ({
  imgStyle: { backgroundSize: 'cover', width: '100%' },
}));

export default function WCHRStanding(props) {
  const location = useLocation();
  const { region } = useParams();
  const regionArr = [
    'Central Mountain',
    'Mid Atlantic',
    'Midwest',
    'Northeast',
    'Northwest',
    'South Central',
    'Southeast',
    'Southwest',
  ];
  const [selectedCategory, setSelectedCategory] = useState(
    props.category[0].value
  );
  const [selectedRegion, setSelectedRegion] = useState(
    region === 'regional' ? regionArr[0] : 'National'
  );
  const [standing, setStanding] = useState([]);

  useEffect(() => {
    document.title = `WCHR ${region === 'national' ? 'National' : 'Regional'} ${
      location.pathname.split('/')[1]
        ? location.pathname.split('/')[1] === 'rider'
          ? 'Rider'
          : 'Owner'
        : ''
    } | United States Hunter Jumper Association`;
  }, []);

  useEffect(() => {
    const year = new URLSearchParams(location.search).get('year');
    getStanding(year, props.type);
  }, [selectedRegion, selectedCategory]);

  return (
    <Grid container justify='center' alignItems='center'>
      <Grid item xs={12}>
        <Grid container direction='row' justify='center' alignItems='center'>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant='h4'
                  style={{
                    color: '#12498a',
                    textTransform: 'uppercase',
                    fontFamily: 'Cinzel',
                    fontWeight: 'bold',
                  }}
                >
                  {`WCHR ${region} ${
                    location.pathname.split('/')[1]
                      ? location.pathname.split('/')[1]
                      : ''
                  } Standings`}
                </Typography>
              </Grid>
              <Grid item xs={12} spacing={3}>
                {region === 'regional' && (
                  <select
                    style={{ marginRight: 20, width: 180 }}
                    onChange={(e) => {
                      setSelectedRegion(e.target.value);
                    }}
                  >
                    {regionArr.map((reg) => {
                      return <option>{reg}</option>;
                    })}
                  </select>
                )}

                <select
                  value={selectedCategory}
                  onChange={(e) => {
                    setSelectedCategory(e.target.value);
                  }}
                >
                  {props.category.map((cat) => {
                    return <option value={cat.value}>{cat.text}</option>;
                  })}
                </select>
              </Grid>
              <Grid item xs={12}>
                <table
                  style={{
                    backgroundColor: '#b01e3f',
                    color: 'white',
                    padding: 4,
                  }}
                >
                  <tbody>
                    <tr>
                      {props.tableHeader.map((header) => {
                        return <th width={header.width}>{header.header}</th>;
                      })}
                    </tr>
                  </tbody>
                </table>
              </Grid>
              <Grid item xs={12}>
                {standing.length === 0 ? (
                  <Typography style={{ textAlign: 'center' }}>
                    No Data
                  </Typography>
                ) : (
                  <table>
                    <tbody>
                      {standing &&
                        standing.map((row, index) => {
                          return props.type === 'rider' ? (
                            <StandindRow row={row} index={index} />
                          ) : (
                            <StandingOwnerTableRow row={row} index={index} />
                          );
                        })}
                    </tbody>
                  </table>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  function getStanding(year, type) {
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/standing/${type}?year=${year}&category=${selectedCategory}&region=${
          selectedRegion === 'National' ? '' : selectedRegion
        }`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((result) => {
        if (result.status === 200) {
          const orderData = _.orderBy(result.data, ['totalPoints'], ['desc']);
          let rankedStanding = [];
          var arr = _.map(orderData, 'totalPoints');
          var sorted = arr.slice().sort(function (a, b) {
            return b - a;
          });
          var ranks = arr.map(function (v) {
            return sorted.indexOf(v) + 1;
          });
          for (let i = 0; i < orderData.length; i++) {
            rankedStanding.push({ ...orderData[i], rank: ranks[i] });
          }
          setStanding(rankedStanding);
        }
      });
  }
}
